// extracted by mini-css-extract-plugin
export var blue = "_2f-g";
export var brand = "_2f-c";
export var darkGrey = "_2f-f";
export var disabled = "_2f-6";
export var disabledSubtle = "_2f-7";
export var error = "_2f-8";
export var green = "_2f-h";
export var grey = "_2f-e";
export var icon = "_2f-0";
export var inherit = "_2f-b";
export var lightGrey = "_2f-d";
export var orange = "_2f-j";
export var pink = "_2f-l";
export var primary = "_2f-1";
export var purple = "_2f-m";
export var quaternary = "_2f-4";
export var quinary = "_2f-5";
export var red = "_2f-k";
export var secondary = "_2f-2";
export var success = "_2f-a";
export var tertiary = "_2f-3";
export var warning = "_2f-9";
export var white = "_2f-n";
export var yellow = "_2f-i";